export const ACCESSIBILITY_TYPE = {
  OPEN: 'OPEN',
  DIRECT: 'DIRECT',
};

export const INSURANCE_REQUIREMENT = {
  INSURANCE_OR_SELF_PAY: 'INSURANCEORSELFPAY',
  INSURANCE_ONLY: 'INSURANCEONLY',
};

export const REFERRAL_REQUIREMENT = {
  NONE: 'NONE',
  ONLINE: 'ONLINE',
  CHECKIN: 'CHECKIN',
};
